<template>
  <v-menu v-model="showDatePickMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
    <template v-slot:activator="{on, attrs}">
      <!-- text field -->
      <v-text-field
        :value="formattedDate"
        v-bind="attrs"
        v-on="on"
        v-on:input="$emit('input', $event)"
        :rules="commonRules"
        :label="label"
        :hint="hint"
        :persistent-hint="hintIsPersistend"
        :prepend-icon="prependIcon"
        :readonly="textFieldIsReadonly" />
    </template>

    <!-- date picker -->
    <v-date-picker v-model="selected" no-title></v-date-picker>
  </v-menu>
</template>

<script>
import Validation from "@/mixins/validationRules.js";

export default {
  name: "DatePicker",

  mixins: [Validation],

  emits: ["input"],

  props: {
    /**
     * passed: will be set as default value
     *
     * not passed: default value is ""
     */
    value: String,
    /** the label of the textbox */
    label: String,
    /** the hint of the textbox */
    hint: String,
    /** icon which is placed in front of the textbox  */
    prependIcon: String,
    /** whether the hint should always be displayed */
    hintIsPersistend: Boolean,
    /** makes the textbox readonly */
    textFieldIsReadonly: Boolean,
    /**
     * true: onDateInput returns a UTCString
     *
     * false: date in the format of the current locale
     */
    returnUTCString: Boolean,
  },

  data: () => ({
    // whether to show the date selection
    showDatePickMenu: false,
  }),

  computed: {
    formattedDate() {
      if (!this.value) return "";
      return this.$d(new Date(this.value), "longDate");
    },
    selected: {
      get() {
        if (!this.value) return "";
        return new Date(this.value).toISOString();
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  watch: {
    async value(newVal, oldVal) {
      this.datePickerDateISO = new Date(newVal).toISOString();
      await this.$nextTick();
      this.showDatePickMenu = false;
    },
  },
};
</script>

<style></style>
